import * as React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { NotificationInfo, UserInfo } from "./context";
import "./App.css";
// import HomeRoute from "./routes/HomeRoute"
import AllRoute from "./routes/AllRoute.js";
import { Typography, Spin, Space, message } from "antd";
import LoginRoute from "./routes/LoginRoute";

axios.defaults.baseURL = process.env.REACT_APP_API;
axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
  "comtkn"
)}`;

function MyApp() {
  const comtkn = localStorage.getItem("comtkn");
  const [isLoading, setIsLoading] = React.useState(false);
  const [userData, setUserData] = React.useState({
    data: [],
    ready: false,
  });
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  const messagingNotif = (type, content) => {
    messageApi.open({
      type,
      content,
    });
  };

  const handleLogout = () => {
    messagingNotif("error", "Session Expire! Logged out automatically.");
    setTimeout(() => {
      localStorage.removeItem("comtkn");
      navigate("/");
      navigate(0);
    }, 1000);
  };

  const getTokenAndAccess = () => {
    axios
      .get("user/me")
      .then(function (response) {
        if (response.data.message === "success") {
          // console.log("response.data", response.data);
          setUserData({
            data: response.data.data,
            ready: true,
          });
          setTimeout(() => {
            setIsLoading(false);
          }, 500);
        }
      })
      .catch(function (error) {
        if (error.message === "Request failed with status code 401") {
          handleLogout();
          setTimeout(() => {
            setIsLoading(false);
          }, 500);
        }
      });
  };

  const handleLogoutTkn = () => {
    axios
      .post("user/logout")
      .then(function (response) {
        console.log("response.data", response.data);
        messagingNotif("success", "Logged out successfully.");
        localStorage.removeItem("comtkn");
        navigate("/");
        navigate(0);
      })
      .catch(function (error) {
        console.log("ERROR: ", error);
      });
  };

  function DisableDevTools() {
    // const body = document.getElementsByTagName("body");
    // console.log("TPY", typeof window);
    document.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });
    document.onkeydown = function (e) {
      // body[0].innerHTML = "sorry, you can't do this 💔";
      if (e.keyCode === 123) {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode === "I".charCodeAt(0)) {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode === "C".charCodeAt(0)) {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode === "J".charCodeAt(0)) {
        return false;
      }
      if (e.ctrlKey && e.keyCode === "U".charCodeAt(0)) {
        return false;
      }
    };
  }

  React.useEffect(() => {
    DisableDevTools();
    if (comtkn !== null) {
      setIsLoading(true);
      getTokenAndAccess();
    }
    // eslint-disable-next-line
  }, [comtkn]);
  return (
    <>
      <UserInfo.Provider
        value={{
          userData,
          setUserData,
          handleRerunUser: () => getTokenAndAccess(),
          handleLogoutTkn: () => handleLogoutTkn(),
        }}
      >
        <NotificationInfo.Provider
          value={{
            rerunNotif: (type, content) => messagingNotif(type, content),
          }}
        >
          {isLoading ? (
            <Space
              direction="vertical"
              size={0}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100vh",
              }}
            >
              <Spin
                size="large"
                tip={
                  <Typography.Title
                    level={4}
                    style={{ paddingTop: 5, margin: 0 }}
                  >
                    Loading...
                  </Typography.Title>
                }
              />
            </Space>
          ) : (
            <>{userData.ready ? <AllRoute /> : <LoginRoute />}</>
          )}
        </NotificationInfo.Provider>
      </UserInfo.Provider>

      {contextHolder}
    </>
  );
}

export default function ToggleColorMode() {
  return <MyApp />;
}
